import { defineMessages, MessageDescriptor } from "react-intl";
import { TrajectoryPointDtoVehicleType } from "@/api/generated/models/trajectoryPointDtoVehicleType";

const messages = defineMessages({
  car: {
    id: "vehicleType.car",
    defaultMessage: "Car",
  },
  bus: {
    id: "vehicleType.bus",
    defaultMessage: "Bus",
  },
  truck: {
    id: "vehicleType.truck",
    defaultMessage: "Truck",
  },
  motorcycle: {
    id: "vehicleType.motorcycle",
    defaultMessage: "Motorcycle",
  },
  bike: {
    id: "vehicleType.bike",
    defaultMessage: "Bike",
  },
  pedestrian: {
    id: "vehicleType.pedestrian",
    defaultMessage: "Pedestrian",
  },
});

export const vehicleTypeLabels: Record<
  TrajectoryPointDtoVehicleType,
  MessageDescriptor
> = {
  [TrajectoryPointDtoVehicleType.car]: messages.car,
  [TrajectoryPointDtoVehicleType.bus]: messages.bus,
  [TrajectoryPointDtoVehicleType.truck]: messages.truck,
  [TrajectoryPointDtoVehicleType.motorcycle]: messages.motorcycle,
  [TrajectoryPointDtoVehicleType.bike]: messages.bike,
  [TrajectoryPointDtoVehicleType.pedestrian]: messages.pedestrian,
};
